import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Signin from "../pages/Auth/Signin";
import Signup from "../pages/Auth/Signup";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import ResetPassword from "../pages/Auth/ResetPassword";
import Layout from "../Layout";
import Dashboard from "../pages/Dashboard";
import AccountMetrics from "../pages/AccountMetrics";
import Profile from "../pages/Profile";
import Affiliate from "../pages/Affiliate";
import Accounts from "../pages/Accounts";
import Leaderboard from "../pages/Leaderboard";
import Payout from "../pages/Payout";
import Download from "../pages/Download";
import Certificates from "../pages/Certificates";
import Billing from "../pages/Billing/BillingHistory";
import CompetitionPage from "../pages/Competition";
import CompetitonDetail from "../components/Competition/CompetitonDetail";
import PublicRoutes from "./public/PublicRoute";
import PrivateRouter from "./Private/PrivateRouter";
import ChallengeComponent from "../components/Funding";
import Plans from "../components/Funding/Plans";
import Payments from "../pages/Payments/GetFundedCheckOut/index";
// import PaymentHistory from "../pages/Billing/BillingHistory/BillingHistory";
import SuccessPayment from "../components/BillingDetails/PaymentMethods/success";
import FailPayment from "../components/BillingDetails/PaymentMethods/fail";
import KycVerification from "../components/Profile/KYC/KycVerification";
import AlphaTicksPerformanceTracker from "../pages/AlphaTicksPerformanceTracker/AlphaTicksPerformanceTracker";
import ContractList from "../pages/Contracts/ContractsList";
import ContractSigned from "../pages/Contracts/ContractSigned";
import RePayment from "../pages/Contracts/RePayment";
import GoogleAuth from "../components/Auth/Google/Index";
import PublicCertificate from "../pages/Certificates/PublicCertificate/PublicCertificate";
import PublicAccountMetrics from "../pages/PublicAccountMetrics";
import AccountAnalysis from "../pages/AccountAnalysis/AccountAnalysis";
import Trading from "../pages/Trading/Trading";
import AdminLogin from "../pages/Auth/AdminLogin/AdminLogin";
import TradeDetailsPage from "../components/AccountMetrics/TradingPlotingChart/TradingChart";

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route
          path="/public-account-stats/:login_id"
          element={<PublicAccountMetrics />}
        />
        <Route
          path="/share-certificates/:certificate_id"
          element={<PublicCertificate />}
        />
        <Route
          path="/admin-login/:idToken/:refreshToken"
          element={<AdminLogin />}
        />
        <Route element={<PublicRoutes />}>
          <Route path="/signin" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/auth/google/" element={<GoogleAuth />} />
          <Route path="/signup/:ref" element={<Signup mode="ref" />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/signin" />} />
        </Route>
        {/* Private Routes */}

        <Route element={<PrivateRouter />}>
          <Route
            path="/"
            element={
              <Layout headerName="Dashboard">
                <Dashboard />
              </Layout>
            }
          />
          <Route
            path="/public-account-stats/:login_id"
            element={<PublicAccountMetrics />}
          />
          <Route
            path="/share-certificates/:certificate_id"
            element={<PublicCertificate />}
          />

          <Route
            path="/account-stats"
            element={
              <Layout headerName="Account Stats">
                <AccountMetrics />
              </Layout>
            }
          />
          <Route
            path="trading-history"
            element={
              <Layout headerName="Trading History">
                <Trading />
              </Layout>
            }
          />
          <Route path="/trade-details" element={<TradeDetailsPage />} />
          <Route
            path="/account-analysis/*"
            element={
              <Layout headerName="Account Analysis">
                <AccountAnalysis />
              </Layout>
            }
          />

          <Route
            path="/billing-details/*"
            element={
              <Layout headerName="Billing Details">
                <Billing />
              </Layout>
            }
          />

          <Route
            path="/affiliate/*"
            element={
              <Layout headerName="Affiliate">
                <Affiliate />
              </Layout>
            }
          />

          <Route
            path="/accounts"
            element={
              <Layout headerName="Accounts">
                <Accounts />
              </Layout>
            }
          />
          <Route
            path="/Assessments"
            element={
              <Layout headerName="Assessments">
                <Plans />
              </Layout>
            }
          />

          <Route
            path="/leaderboard"
            element={
              <Layout headerName="Leaderboard">
                <Leaderboard />
              </Layout>
            }
          />

          <Route
            path="/payout/*"
            element={
              <Layout headerName="Payout">
                <Payout />
              </Layout>
            }
          />
          <Route
            path="/downloads"
            element={
              <Layout headerName="Downloads">
                <Download />
              </Layout>
            }
          />
          <Route
            path="/profile/*"
            element={
              <Layout headerName="Profile">
                <Profile />
              </Layout>
            }
          />
          <Route
            path="/kyc-verification"
            element={
              <Layout headerName="Kyc Verification">
                <KycVerification />
              </Layout>
            }
          />

          <Route
            path="/certificates"
            element={
              <Layout headerName="Certificates">
                <Certificates />
              </Layout>
            }
          />

          <Route
            path="/competition/*"
            element={
              <Layout headerName="Competition">
                <CompetitionPage />
              </Layout>
            }
          />
          <Route
            path="/contract-lists"
            element={
              <Layout headerName="Contract List">
                <ContractList />
              </Layout>
            }
          />
          <Route
            path="/contract-lists/payment"
            element={
              <Layout headerName="Contract Payment">
                <RePayment />
              </Layout>
            }
          />
          <Route
            path="/doc/signing_completed/*"
            element={
              <Layout headerName="contract signed">
                <ContractSigned />
              </Layout>
            }
          />
          <Route
            path="/competition/:id"
            element={
              <Layout headerName="Competition">
                <CompetitonDetail />
              </Layout>
            }
          />
          <Route
            path="/Assessments-checkout/:id"
            element={
              <Layout headerName="Billing">
                <Payments />
              </Layout>
            }
          />
          <Route
            path="/evaluation/payment/success/"
            element={
              <Layout headerName="Payment Status">
                <SuccessPayment />
              </Layout>
            }
          />
          <Route
            path="/evaluation/payment/failure"
            element={
              <Layout headerName="Payment Status">
                <FailPayment />
              </Layout>
            }
          />
          <Route
            path="/evaluation/payment/cancelled"
            element={
              <Layout headerName="Payment Status">
                <FailPayment />
              </Layout>
            }
          />
          <Route
            path="/Assessments-checkout/paymenthistory"
            element={
              <Layout headerName="Competition">
                {/* <PaymentHistory /> */}
              </Layout>
            }
          />
          {/* <Route
            path="/performance-tracker"
            element={
              <Layout headerName="Performance Tracker">
                <AlphaTicksPerformanceTracker />
              </Layout>
            }
          /> */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
